module.exports = __webpack_public_path__ + "5cbb5c4f0bdb3361a7b54ccf806e5102.MP3";